import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SchedulesV2Component } from './schedules-v2.component';
import { AuthenticationGuard } from 'src/app/common/guards/authentication.guard';

const routes: Routes = [
  { path: 'schedulesV2/:type', component: SchedulesV2Component, canActivate: [AuthenticationGuard], }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ScheduleRoutingModule { }
